const RELATION_COLORS = {
  family: '#f97316',
  friend: '#10b981',
  work: '#3b82f6',
  partner: '#ec4899',
  other: '#8b5cf6'
};

export const getRelationColor = (relation) => {
  return RELATION_COLORS[relation?.toLowerCase()] || RELATION_COLORS.other;
};
